"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueFromObj = void 0;
var value = function (v, p) {
    if (p.length === 0) {
        return v;
    }
    var f = p.shift();
    if (f) {
        if (v.hasOwnProperty(f)) {
            return value(v[f], p);
        }
        else {
            throw new Error('Missing property');
        }
    }
    else {
        throw new Error('Failed to shift!');
    }
};
exports.valueFromObj = function (obj, path) {
    var fields = path.split('.');
    try {
        return value(obj, fields);
    }
    catch (err) {
        throw new Error("Invalid path \"" + path + "\" - " + err.message);
    }
};
